function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurvision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M453.858,231.481c15.699-100.421-68.074-201.639-178.07-214.21 c-1.369-0.156-2.74-0.303-4.112-0.439c-76.857-7.634-147.111,51.075-167.198,95.853s-72.657,87.376-53.172,170.372 c19.485,82.996,72.42,127.217,196.53,140.305c124.11,13.088,147.009-22.408,179.956-99.95 C439.208,296.542,448.702,264.459,453.858,231.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M453.858,231.481c15.699-100.421-68.074-201.639-178.07-214.21 c-1.369-0.156-2.74-0.303-4.112-0.439c-76.857-7.634-147.111,51.075-167.198,95.853s-72.657,87.376-53.172,170.372 c19.485,82.996,72.42,127.217,196.53,140.305c124.11,13.088,147.009-22.408,179.956-99.95 C439.208,296.542,448.702,264.459,453.858,231.481z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.15
    },
    cx: 255.337,
    cy: 451.391,
    rx: 193.676,
    ry: 27.215
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M466.09,389.564c-2.277-1.066-5.899-5.364-5.901-5.367c-0.037-0.045,3.576-1.504,3.815-1.57 c2.763-0.765,8.557-0.631,10.332,2.03c1.278,1.917,0.392,4.369-1.574,5.392C470.754,391.093,468.03,390.471,466.09,389.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M452.518,398.772c-1.839-1.56-4.058-6.274-4.233-6.65c-2.643,1.245-5.458,2.31-8.366,3.232 c-1.662,0.529-3.353,1.01-5.054,1.472c0.808-0.096,1.532-0.175,1.635-0.176c2.87-0.013,8.425,1.635,9.429,4.665 c0.724,2.183-0.784,4.314-2.953,4.785c-2.215,0.482-4.679-0.832-6.309-2.215c-1.654-1.403-3.627-5.385-4.135-6.446 c-0.655,0.17-1.306,0.348-1.961,0.515c-3.144,0.805-6.284,1.595-9.341,2.464c-1.077,0.305-2.127,0.646-3.178,0.982 c0.718-0.085,1.324-0.15,1.418-0.15c2.869-0.013,8.425,1.634,9.429,4.665c0.724,2.183-0.784,4.315-2.953,4.785 c-2.216,0.481-4.679-0.832-6.309-2.215c-1.579-1.339-3.433-4.998-4.043-6.256c-1.066,0.377-2.135,0.752-3.151,1.165 c-0.687,0.298-1.37,0.536-2.043,0.874c-0.674,0.32-1.341,0.636-2.002,0.95c-1.25,0.65-2.544,1.313-3.746,1.977 c-0.84,0.456-1.633,0.906-2.432,1.357c1.069-0.316,3.174-0.893,3.356-0.921c2.833-0.445,8.574,0.35,10.03,3.195 c1.048,2.05-0.116,4.384-2.188,5.175c-2.116,0.808-4.75-0.119-6.572-1.242c-2.006-1.236-4.824-5.381-5.173-5.901 c-1.32,0.751-2.597,1.493-3.791,2.213c-1.071,0.643-2.078,1.263-3.035,1.862l-1.327-1.504c1.063-0.636,2.187-1.297,3.392-1.985 c1.337-0.768,2.782-1.561,4.273-2.362c-0.135-0.378-0.891-2.533-1.342-4.632c-2.424-0.067-6.769-1.855-7.328-2.09 c-0.683,1.349-1.334,2.668-1.928,3.922c-0.411,0.863-0.799,1.694-1.167,2.498l-1.405-1.594c0.277-0.566,0.56-1.138,0.859-1.732 c0.687-1.373,1.45-2.827,2.247-4.311c-0.493-0.369-4.508-3.409-5.636-5.471c-1.022-1.87-1.801-4.535-0.863-6.583 c0.918-2.005,3.335-3.021,5.336-1.862c2.777,1.608,3.239,7.341,2.624,10.121c-0.036,0.164-0.629,1.9-1.022,2.988 c0.329-0.605,0.642-1.196,0.988-1.815c0.676-1.229,1.388-2.434,2.148-3.734c0.389-0.615,0.783-1.236,1.18-1.864 c0.381-0.63,0.864-1.248,1.297-1.88c1.036-1.445,2.156-2.859,3.316-4.258c-1.083-0.592-4.9-2.749-6.202-4.452 c-1.296-1.696-2.472-4.212-1.858-6.378c0.601-2.121,2.835-3.489,4.989-2.644c2.99,1.173,4.321,6.771,4.139,9.612 c-0.011,0.177-0.373,2.201-0.593,3.308c0.704-0.836,1.403-1.673,2.143-2.496c2.136-2.375,4.373-4.713,6.594-7.055 c0.681-0.717,1.35-1.44,2.023-2.161c-0.388-0.207-4.98-2.673-6.438-4.581c-1.296-1.695-2.473-4.212-1.858-6.378 c0.601-2.12,2.835-3.488,4.989-2.643c2.99,1.173,4.322,6.771,4.139,9.612c-0.014,0.214-0.539,3.125-0.709,3.859 c1.482-1.589,2.944-3.185,4.32-4.817c1.902-2.249,3.643-4.56,5.163-6.923c-0.181-0.096-4.986-2.648-6.479-4.602 c-1.296-1.696-2.473-4.213-1.858-6.378c0.601-2.12,2.835-3.488,4.989-2.643c2.99,1.173,4.321,6.771,4.139,9.612 c-0.015,0.223-0.581,3.355-0.724,3.915c0.09-0.141,0.199-0.277,0.287-0.418c1.59-2.543,2.808-5.205,3.825-7.754 c0.594-1.479,1.078-2.927,1.518-4.345c-0.944-0.384-5.238-2.189-6.778-3.8c-1.476-1.544-2.923-3.918-2.553-6.138 c0.363-2.174,2.431-3.777,4.665-3.172c3.102,0.84,5.044,6.26,5.178,9.105c0.007,0.154-0.095,1.735-0.185,2.884 c0.189-0.643,0.395-1.303,0.563-1.923c0.637-2.326,1.076-4.495,1.449-6.419c0.203-1.095,0.365-2.09,0.507-3.023 c-0.729-0.856-3.621-4.344-4.229-6.438c-0.592-2.044-0.777-4.811,0.583-6.611c1.332-1.762,3.914-2.238,5.617-0.68 c2.365,2.163,1.573,7.858,0.37,10.441c-0.104,0.223-2.134,3.529-2.172,3.484c0,0-0.036-0.041-0.044-0.051 c-0.118,0.9-0.255,1.863-0.426,2.913c-0.331,1.936-0.723,4.12-1.312,6.469c-0.582,2.349-1.281,4.884-2.26,7.489 c-0.978,2.612-2.141,5.309-3.702,7.934c-0.017,0.03-0.04,0.058-0.057,0.088c0.697-0.627,2.706-2.315,2.874-2.427 c2.384-1.582,7.928-3.247,10.451-1.267c1.816,1.427,1.746,4.031,0.2,5.612c-1.579,1.614-4.361,1.866-6.489,1.603 c-2.399-0.296-6.869-3.017-7.225-3.235c-1.509,2.486-3.263,4.916-5.173,7.277c-1.091,1.352-2.232,2.679-3.394,3.995 c0.621-0.523,1.179-0.986,1.264-1.042c2.384-1.582,7.928-3.247,10.45-1.267c1.817,1.426,1.746,4.031,0.2,5.612 c-1.578,1.614-4.361,1.866-6.488,1.604c-2.159-0.267-6.017-2.511-7.03-3.118c-0.451,0.5-0.896,1.005-1.348,1.504 c-2.172,2.393-4.35,4.771-6.413,7.169c-0.728,0.845-1.413,1.703-2.102,2.559c0.551-0.463,1.02-0.849,1.097-0.901 c2.384-1.582,7.928-3.247,10.45-1.267c1.817,1.427,1.746,4.032,0.2,5.613c-1.578,1.614-4.361,1.866-6.488,1.603 c-2.06-0.254-5.64-2.294-6.847-3.01c-0.679,0.898-1.36,1.797-1.977,2.698c-0.407,0.625-0.843,1.198-1.217,1.848 c-0.383,0.635-0.763,1.265-1.14,1.888c-0.68,1.227-1.389,2.488-2.022,3.701c-0.447,0.841-0.857,1.65-1.272,2.464 c0.715-0.849,2.149-2.482,2.284-2.605c1.405-1.277,4.182-2.794,6.708-3.209c0.206-0.19,0.428-0.361,0.667-0.51 c1.882-1.168,4.465-0.692,5.491,1.369c1.424,2.86-1.378,7.889-3.436,9.869c-0.121,0.117-1.582,1.238-2.515,1.931 c0.611-0.324,1.201-0.646,1.834-0.971c1.248-0.653,2.512-1.268,3.87-1.936c0.667-0.299,1.341-0.601,2.022-0.906 c0.668-0.317,1.415-0.567,2.128-0.857c1.668-0.637,3.39-1.202,5.136-1.733c-0.576-1.087-2.563-4.973-2.702-7.104 c-0.139-2.122,0.278-4.863,1.995-6.332c1.681-1.438,4.307-1.356,5.635,0.528c1.845,2.614-0.157,8.008-1.888,10.275 c-0.108,0.141-1.535,1.629-2.335,2.432c1.052-0.311,2.102-0.627,3.177-0.907c3.104-0.81,6.271-1.535,9.428-2.27 c0.967-0.225,1.928-0.461,2.89-0.693c-0.209-0.385-2.672-4.954-2.828-7.341c-0.139-2.122,0.278-4.863,1.995-6.331 c1.681-1.438,4.306-1.355,5.635,0.528c1.845,2.614-0.156,8.007-1.888,10.275c-0.131,0.171-2.187,2.309-2.737,2.827 c2.12-0.512,4.228-1.042,6.284-1.649c2.839-0.833,5.577-1.805,8.16-2.943c-0.098-0.179-2.689-4.936-2.85-7.382 c-0.139-2.122,0.278-4.863,1.995-6.331c1.681-1.438,4.306-1.355,5.635,0.528c1.845,2.613-0.157,8.007-1.889,10.274 c-0.136,0.178-2.35,2.478-2.781,2.865c0.153-0.068,0.32-0.121,0.472-0.19c2.742-1.25,5.239-2.801,7.505-4.368 c1.318-0.907,2.527-1.848,3.682-2.79c-0.574-0.837-3.156-4.691-3.545-6.876c-0.373-2.095-0.262-4.865,1.281-6.512 c1.512-1.613,4.13-1.817,5.659-0.09c2.122,2.397,0.731,7.977-0.739,10.42c-0.08,0.133-1.043,1.394-1.758,2.302 c0.515-0.433,1.055-0.87,1.54-1.294c1.825-1.589,3.397-3.156,4.779-4.555c0.779-0.802,1.467-1.543,2.103-2.242 c-0.132-1.112-0.607-5.602,0.05-7.68c0.641-2.028,2.027-4.434,4.162-5.188c2.092-0.739,4.512,0.277,5.068,2.508 c0.771,3.096-3.056,7.408-5.496,8.903c-0.211,0.129-3.744,1.772-3.752,1.714c0,0-0.006-0.054-0.008-0.067 c-0.599,0.685-1.249,1.413-1.976,2.194c-1.353,1.432-2.895,3.037-4.692,4.672c-1.792,1.638-3.785,3.369-6.051,5.003 c-2.268,1.641-4.74,3.252-7.503,4.584c-0.031,0.015-0.066,0.027-0.097,0.042c0.931-0.141,3.546-0.447,3.75-0.448 c2.87-0.014,8.424,1.634,9.429,4.664c0.723,2.183-0.784,4.315-2.954,4.786C456.611,401.468,454.148,400.155,452.518,398.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M427.561,347.74c-0.056-0.017,2.144-3.213,2.306-3.399c1.877-2.15,6.78-5.209,9.739-3.96 c2.131,0.9,2.755,3.432,1.685,5.362c-1.092,1.971-3.707,2.943-5.828,3.247C432.972,349.348,427.565,347.741,427.561,347.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M28.496,389.564c2.277-1.066,5.898-5.364,5.902-5.367c0.037-0.045-3.577-1.504-3.815-1.57 c-2.763-0.765-8.557-0.631-10.332,2.03c-1.278,1.917-0.392,4.369,1.574,5.392C23.832,391.093,26.556,390.471,28.496,389.564z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M42.068,398.772c1.839-1.56,4.058-6.274,4.233-6.65c2.643,1.245,5.458,2.31,8.366,3.232 c1.662,0.529,3.353,1.01,5.054,1.472c-0.808-0.096-1.532-0.175-1.634-0.176c-2.87-0.013-8.425,1.635-9.429,4.665 c-0.724,2.183,0.784,4.314,2.953,4.785c2.215,0.482,4.679-0.832,6.309-2.215c1.654-1.403,3.627-5.385,4.136-6.446 c0.655,0.17,1.306,0.348,1.961,0.515c3.144,0.805,6.284,1.595,9.341,2.464c1.077,0.305,2.127,0.646,3.178,0.982 c-0.718-0.085-1.324-0.15-1.418-0.15c-2.869-0.013-8.424,1.634-9.429,4.665c-0.724,2.183,0.784,4.315,2.953,4.785 c2.216,0.481,4.679-0.832,6.309-2.215c1.579-1.339,3.433-4.998,4.043-6.256c1.066,0.377,2.135,0.752,3.151,1.165 c0.687,0.298,1.37,0.536,2.043,0.874c0.674,0.32,1.341,0.636,2.002,0.95c1.249,0.65,2.543,1.313,3.746,1.977 c0.84,0.456,1.633,0.906,2.432,1.357c-1.069-0.316-3.174-0.893-3.356-0.921c-2.833-0.445-8.574,0.35-10.03,3.195 c-1.048,2.05,0.116,4.384,2.188,5.175c2.116,0.808,4.75-0.119,6.572-1.242c2.006-1.236,4.824-5.381,5.173-5.901 c1.32,0.751,2.597,1.493,3.791,2.213c1.071,0.643,2.078,1.263,3.035,1.862l1.327-1.504c-1.063-0.636-2.187-1.297-3.391-1.985 c-1.337-0.768-2.782-1.561-4.273-2.362c0.136-0.378,0.891-2.533,1.342-4.632c2.424-0.067,6.769-1.855,7.328-2.09 c0.683,1.349,1.334,2.668,1.928,3.922c0.411,0.863,0.799,1.694,1.167,2.498l1.405-1.594c-0.277-0.566-0.56-1.138-0.859-1.732 c-0.688-1.373-1.45-2.827-2.247-4.311c0.493-0.369,4.508-3.409,5.636-5.471c1.022-1.87,1.801-4.535,0.863-6.583 c-0.918-2.005-3.335-3.021-5.337-1.862c-2.777,1.608-3.239,7.341-2.624,10.121c0.036,0.164,0.63,1.9,1.022,2.988 c-0.329-0.605-0.641-1.196-0.988-1.815c-0.676-1.229-1.388-2.434-2.148-3.734c-0.389-0.615-0.783-1.236-1.18-1.864 c-0.381-0.63-0.864-1.248-1.297-1.88c-1.035-1.445-2.156-2.859-3.316-4.258c1.083-0.592,4.9-2.749,6.202-4.452 c1.296-1.696,2.472-4.212,1.858-6.378c-0.601-2.121-2.835-3.489-4.989-2.644c-2.99,1.173-4.321,6.771-4.139,9.612 c0.011,0.177,0.373,2.201,0.593,3.308c-0.704-0.836-1.403-1.673-2.143-2.496c-2.136-2.375-4.373-4.713-6.594-7.055 c-0.681-0.717-1.35-1.44-2.023-2.161c0.388-0.207,4.98-2.673,6.438-4.581c1.296-1.695,2.473-4.212,1.858-6.378 c-0.601-2.12-2.835-3.488-4.989-2.643c-2.99,1.173-4.322,6.771-4.139,9.612c0.014,0.214,0.539,3.125,0.709,3.859 c-1.482-1.589-2.943-3.185-4.32-4.817c-1.902-2.249-3.643-4.56-5.163-6.923c0.181-0.096,4.986-2.648,6.479-4.602 c1.296-1.696,2.472-4.213,1.858-6.378c-0.601-2.12-2.835-3.488-4.989-2.643c-2.99,1.173-4.321,6.771-4.139,9.612 c0.015,0.223,0.581,3.355,0.724,3.915c-0.09-0.141-0.199-0.277-0.287-0.418c-1.59-2.543-2.808-5.205-3.825-7.754 c-0.594-1.479-1.078-2.927-1.518-4.345c0.944-0.384,5.238-2.189,6.778-3.8c1.475-1.544,2.924-3.918,2.552-6.138 c-0.363-2.174-2.431-3.777-4.665-3.172c-3.102,0.84-5.044,6.26-5.178,9.105c-0.007,0.154,0.095,1.735,0.185,2.884 c-0.189-0.643-0.395-1.303-0.563-1.923c-0.637-2.326-1.076-4.495-1.449-6.419c-0.203-1.095-0.365-2.09-0.506-3.023 c0.729-0.856,3.621-4.344,4.229-6.438c0.593-2.044,0.777-4.811-0.583-6.611c-1.332-1.762-3.914-2.238-5.617-0.68 c-2.364,2.163-1.573,7.858-0.37,10.441c0.104,0.223,2.134,3.529,2.172,3.484c0,0,0.036-0.041,0.044-0.051 c0.118,0.9,0.255,1.863,0.426,2.913c0.331,1.936,0.723,4.12,1.312,6.469c0.582,2.349,1.281,4.884,2.259,7.489 c0.978,2.612,2.142,5.309,3.702,7.934c0.017,0.03,0.04,0.058,0.058,0.088c-0.697-0.627-2.705-2.315-2.875-2.427 c-2.383-1.582-7.928-3.247-10.45-1.267c-1.816,1.427-1.746,4.031-0.2,5.612c1.579,1.614,4.361,1.866,6.489,1.603 c2.399-0.296,6.869-3.017,7.225-3.235c1.509,2.486,3.263,4.916,5.173,7.277c1.091,1.352,2.233,2.679,3.394,3.995 c-0.62-0.523-1.179-0.986-1.264-1.042c-2.384-1.582-7.928-3.247-10.45-1.267c-1.817,1.426-1.746,4.031-0.2,5.612 c1.578,1.614,4.361,1.866,6.488,1.604c2.159-0.267,6.017-2.511,7.03-3.118c0.451,0.5,0.896,1.005,1.348,1.504 c2.172,2.393,4.35,4.771,6.413,7.169c0.728,0.845,1.413,1.703,2.102,2.559c-0.551-0.463-1.02-0.849-1.097-0.901 c-2.384-1.582-7.928-3.247-10.45-1.267c-1.817,1.427-1.746,4.032-0.2,5.613c1.578,1.614,4.361,1.866,6.489,1.603 c2.059-0.254,5.64-2.294,6.847-3.01c0.679,0.898,1.36,1.797,1.977,2.698c0.407,0.625,0.842,1.198,1.217,1.848 c0.383,0.635,0.764,1.265,1.14,1.888c0.68,1.227,1.389,2.488,2.022,3.701c0.447,0.841,0.856,1.65,1.272,2.464 c-0.715-0.849-2.149-2.482-2.284-2.605c-1.405-1.277-4.182-2.794-6.708-3.209c-0.206-0.19-0.428-0.361-0.667-0.51 c-1.882-1.168-4.465-0.692-5.491,1.369c-1.424,2.86,1.378,7.889,3.436,9.869c0.121,0.117,1.582,1.238,2.515,1.931 c-0.611-0.324-1.201-0.646-1.834-0.971c-1.248-0.653-2.512-1.268-3.87-1.936c-0.667-0.299-1.341-0.601-2.022-0.906 c-0.668-0.317-1.415-0.567-2.128-0.857c-1.668-0.637-3.39-1.202-5.136-1.733c0.576-1.087,2.563-4.973,2.702-7.104 c0.14-2.122-0.278-4.863-1.995-6.332c-1.681-1.438-4.307-1.356-5.635,0.528c-1.844,2.614,0.157,8.008,1.888,10.275 c0.108,0.141,1.535,1.629,2.335,2.432c-1.052-0.311-2.102-0.627-3.177-0.907c-3.104-0.81-6.271-1.535-9.428-2.27 c-0.967-0.225-1.927-0.461-2.89-0.693c0.209-0.385,2.672-4.954,2.828-7.341c0.139-2.122-0.278-4.863-1.995-6.331 c-1.681-1.438-4.306-1.355-5.635,0.528c-1.845,2.614,0.156,8.007,1.888,10.275c0.131,0.171,2.187,2.309,2.737,2.827 c-2.12-0.512-4.228-1.042-6.285-1.649c-2.839-0.833-5.577-1.805-8.16-2.943c0.098-0.179,2.689-4.936,2.85-7.382 c0.139-2.122-0.278-4.863-1.995-6.331c-1.681-1.438-4.306-1.355-5.635,0.528c-1.844,2.613,0.157,8.007,1.889,10.274 c0.136,0.178,2.35,2.478,2.781,2.865c-0.153-0.068-0.32-0.121-0.472-0.19c-2.742-1.25-5.239-2.801-7.505-4.368 c-1.318-0.907-2.527-1.848-3.682-2.79c0.574-0.837,3.156-4.691,3.545-6.876c0.373-2.095,0.262-4.865-1.281-6.512 c-1.512-1.613-4.13-1.817-5.659-0.09c-2.122,2.397-0.73,7.977,0.739,10.42c0.08,0.133,1.043,1.394,1.758,2.302 c-0.515-0.433-1.055-0.87-1.54-1.294c-1.825-1.589-3.397-3.156-4.778-4.555c-0.779-0.802-1.467-1.543-2.103-2.242 c0.132-1.112,0.607-5.602-0.05-7.68c-0.641-2.028-2.027-4.434-4.163-5.188c-2.092-0.739-4.512,0.277-5.068,2.508 c-0.771,3.096,3.057,7.408,5.497,8.903c0.211,0.129,3.744,1.772,3.752,1.714c0,0,0.007-0.054,0.008-0.067 c0.598,0.685,1.249,1.413,1.976,2.194c1.353,1.432,2.895,3.037,4.692,4.672c1.792,1.638,3.785,3.369,6.051,5.003 c2.269,1.641,4.74,3.252,7.503,4.584c0.031,0.015,0.066,0.027,0.097,0.042c-0.931-0.141-3.546-0.447-3.75-0.448 c-2.87-0.014-8.424,1.634-9.429,4.664c-0.723,2.183,0.784,4.315,2.954,4.786C37.975,401.468,40.438,400.155,42.068,398.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M67.025,347.74c0.056-0.017-2.144-3.213-2.306-3.399c-1.877-2.15-6.78-5.209-9.739-3.96 c-2.131,0.9-2.756,3.432-1.685,5.362c1.092,1.971,3.707,2.943,5.828,3.247C61.614,349.348,67.021,347.741,67.025,347.74z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shine"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 233.319,45.787 255.473,234.976 272.249,45.008  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 147.936,77.753 255.473,234.976 182.045,58.971  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 87.188,145.737 255.473,234.976 108.662,113.255  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 64.993,234.165 255.473,234.976 68.912,195.424  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 86.434,322.778 255.473,234.976 71.901,286.654  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 146.6,391.277 255.473,234.976 116.944,366.044  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 231.707,423.97 255.473,234.976 193.722,415.409  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 322.259,413.366 255.473,234.976 284.646,423.439  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 397.512,361.896 255.473,234.976 368.888,388.294  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 440.224,281.349 255.473,234.976 427.147,318.026  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 440.613,190.179 255.473,234.976 446.078,228.732  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 398.588,109.272 255.473,234.976 421.344,140.869  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 323.777,57.162 255.473,234.976 358.61,74.564  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Hearts"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M430.879,109.869 c0,0-10.547-16.286-16.289-7.482c-5.742,8.804,17.992,26.031,17.992,26.031s14.929-12.633,15.695-23.734 C449.042,93.582,433.941,99.533,430.879,109.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M81.962,102.064 c0,0-12.469-19.254-19.257-8.845c-6.789,10.409,21.271,30.775,21.271,30.775s17.65-14.935,18.555-28.059 C103.436,82.81,85.583,89.844,81.962,102.064z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M296.296,74.814 c0,0-8.22-12.693-12.695-5.831c-4.475,6.862,14.022,20.287,14.022,20.287s11.635-9.845,12.232-18.497 C310.452,62.121,298.682,66.758,296.296,74.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M200.904,335.479 c0,0-8.22-12.693-12.695-5.831s14.022,20.287,14.022,20.287s11.635-9.845,12.232-18.497 C215.06,322.786,203.291,327.424,200.904,335.479z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M297.064,191.527 l0.179,14.711c0,0,2.512,10.943,2.332,20.451c-0.179,9.508,0.179,33.368,0.179,33.368s-0.538,8.79-1.076,11.482 c-0.538,2.691-0.897,4.126-2.512,6.638c-1.615,2.511-3.409,4.305-5.382,5.023c-1.973,0.718-3.947,1.076-3.588-0.179 s1.076-1.256,2.153-2.153c1.076-0.897,3.229-5.023,3.229-6.458c0-1.435-1.076-4.664-1.076-4.664s-0.538,3.767-1.256,5.741 c-0.718,1.973-2.691,2.153-2.512,0c0.179-2.153,0.359-3.229,0.179-5.023c-0.179-1.794-0.359-6.458,0.538-8.073 c0.897-1.615,3.05-5.561,3.229-6.638c0.179-1.076-5.741-22.784-6.996-28.345c-1.256-5.561-2.512-17.402-3.229-21.348 c-0.718-3.947-1.435-16.505-1.435-16.505L297.064,191.527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M260.581,414.357 c0,0,0.14,3.395,0.719,5.13c0.578,1.735,2.891,4.626,2.891,7.518c0,2.891-1.157,7.518,0.578,11.277 c1.735,3.759,9.253,7.228,12.433,6.072c3.181-1.157,7.229-1.446,6.072-8.096c-1.156-6.65-4.626-13.011-5.494-16.77 c-0.867-3.759-1.446-7.807-1.446-7.807S263.91,406.335,260.581,414.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M246.466,407.128 c0,0-0.14,3.395-0.719,5.13c-0.578,1.735-2.891,4.626-2.891,7.518s1.157,7.518-0.578,11.276 c-1.735,3.759-9.253,7.229-12.433,6.072c-3.181-1.157-7.229-1.446-6.072-8.096c1.156-6.65,4.626-13.011,5.494-16.77 c0.867-3.759,1.446-7.807,1.446-7.807S243.137,399.107,246.466,407.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M285.543,243.651 l-64.231-1.517l-2.465,5.007l1.256,51.308l4.766,51.934l2.326,29.952c-0.47,3.045-1.117,7.264-1.459,9.66 c-0.578,4.048,1.157,12.433,1.735,14.168c0.578,1.735,2.024,5.783,2.024,5.783s6.436,3.975,13.011,1.446 c6.575-2.529,4.915-11.276,4.915-11.276s0.94-39.181,1.446-44.238c0.506-5.058,3.48-65.606,3.48-65.606l3.677-8.47 c0,0,1.228,63.884,1.228,65.402c0,0.674,1.735,11.855,2.602,23.131c0.346,4.503-2.271,25.365-2.024,29.781 c0.68,12.168,2.396,14.995,2.602,15.614c0.506,1.517,1.738,5.132,7.807,4.626c6.069-0.506,9.542-0.867,9.542-0.867 s6.245-65.58,7.256-75.695c1.012-10.115,2.878-73.329,2.878-73.329L285.543,243.651z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M237.29,137.356 c0,0-17.01,9.45-21.306,15.636c-4.295,6.186-1.89,22.165-0.687,31.099c1.203,8.935,3.78,35.567,3.78,35.567l-2.664,41.374 c0,0,25.945,12.199,29.897,12.543c3.952,0.344,6.873,0.687,6.873,0.687l3.713-6.197l3.503,5.853c0,0,6.014-0.344,10.996-2.921 c4.983-2.577,13.058-8.935,13.574-9.45c0.515-0.516,2.062-2.749,2.062-2.749s-4.724-47.044-4.724-48.418 c0-1.375,0.538-11.982,0.538-11.982l-0.023-4.512c0,0,1.375,1.546,5.67,1.203c4.295-0.344,9.106-2.062,9.106-2.062 s1.203-13.574,1.203-23.196c0-9.622-3.952-15.464-6.014-17.869c-2.062-2.406-12.199-8.247-17.525-9.966 c-5.326-1.718-16.495-4.983-17.01-4.983S251.551,133.233,237.29,137.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M283.643,186.759 c0,0,4.846-5.115,9.153-14.268"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M296.566,171.144 c0,0-2.961,5.384-6.192,10.23"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 253.033,
    y1: 163.718,
    x2: 255.872,
    y2: 258.159
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M238.123,134.464c0,0-3.812,4.606-4.299,6.069s-1.46,14.859-1.46,17.053s1.706,2.682,2.926,1.707 c1.219-0.975,5.516-5.325,5.516-5.325l9.264,7.558c0,0,2.233,2.924,2.964,2.193s6.544-6.093,7.519-7.556 c0.975-1.463,3.169-3.413,3.169-3.413s4.388,6.583,6.095,7.558c1.707,0.975,2.194-0.244,1.95-1.463 c-0.244-1.219-2.334-17.337-4.58-20.371c-2.246-3.034-1.515-2.302-5.659-4.496C257.383,131.783,244.949,126.663,238.123,134.464z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M282.574,192.699c0,0,4.206,1.764,7.869,0.814c3.663-0.95,6.376-2.171,7.055-2.849c0.678-0.678,1.357-1.221,1.492,0.814 c0.136,2.035-0.136,5.427,0,6.512c0.136,1.085,1.357,3.12-2.306,5.02c-3.663,1.899-8.411,2.306-10.582,1.628 c-2.171-0.678-3.663-1.492-3.663-1.899S281.624,193.92,282.574,192.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M284.844,174.427 c0,0,0.274,2.33-0.823,8.224c-1.096,5.894-1.199,11.233-1.199,11.233"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M239.524,143.456 c0,0,4.296,10.395,6.873,14.175s7.216,5.155,10.137,2.062c2.921-3.093,6.014-10.309,6.357-12.886 c0.344-2.577,0.687-4.639,0.687-4.639s0.344,4.124-7.216,4.639c-7.56,0.515-16.323-6.186-16.838-6.873 C239.008,139.246,237.462,139.246,239.524,143.456z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M232.995,119.745c0,0-2.234-2.406-3.436,1.89c-1.203,4.295,1.203,6.873,2.406,8.247c1.203,1.375,1.89,1.89,1.89,1.89 s3.78,9.622,5.67,11.684c1.89,2.062,6.873,8.419,10.996,8.935c4.124,0.516,7.732-0.687,9.45-2.921 c1.718-2.234,6.701-8.076,7.216-10.996c0.515-2.921,2.234-7.732,2.234-7.732s4.124-6.529,2.921-9.965 c-1.203-3.436-2.062-1.89-2.062-1.89s0.516-16.151-0.687-21.477c-1.203-5.326-12.543-10.825-20.79-10.309 c-8.247,0.516-15.979,7.045-17.354,10.481c-1.374,3.436-1.89,8.076-1.374,10.653C230.589,110.81,232.995,119.745,232.995,119.745 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M231.576,119.075 l1.419,0.67C232.995,119.745,232.355,119.057,231.576,119.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M269.592,97.409c-1.203-5.326-12.543-10.825-20.79-10.309c-8.247,0.516-15.979,7.045-17.354,10.481 c-1.374,3.436-1.89,8.076-1.374,10.653c0.515,2.577,2.921,11.512,2.921,11.512s0.344,3.608,1.546,3.093 c1.203-0.515,0.859-1.89,0.515-3.78c-0.344-1.89-0.515-2.749-0.344-3.608s0.344-4.811,2.405-7.216 c2.062-2.406,2.234-2.406,4.467-1.546c2.234,0.859,7.045,3.265,12.027,2.062c4.983-1.203,8.591-3.952,10.137-3.265 c1.546,0.687,1.546,5.326,2.234,8.419c0.687,3.093,2.749,4.811,2.749,4.811s-0.344,6.529,0.515,5.155 c0.859-1.374,1.031-4.983,1.031-4.983S270.795,102.735,269.592,97.409z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M247.427,135.638 c0,0-0.687,2.234,0,2.749c0.687,0.516,3.608,1.718,5.326,1.375s3.265-1.546,3.608-2.062c0.344-0.516-0.172-2.234-0.172-2.234"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M245.537,142.167 c0,0,3.78,1.546,6.873,1.203c3.093-0.344,5.67-2.406,5.67-2.406"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 259.111,
    cy: 127.578,
    rx: 1.472,
    ry: 2.218
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M245.635,127.578c0,1.225-0.659,2.218-1.472,2.218c-0.813,0-1.472-0.993-1.472-2.218 c0-1.225,0.659-2.218,1.472-2.218C244.976,125.36,245.635,126.354,245.635,127.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M239.18,123.611 c0,0,3.608-2.577,7.045,0.344"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M255.503,124.126 c0,0,4.124-3.78,9.106,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M222.857,146.635c0,0-12.543,4.467-15.464,10.996c-2.921,6.529-4.124,11.855-2.234,16.838 c1.89,4.983,11.512,24.055,14.261,27.663c2.749,3.608,6.357,7.216,8.935,10.481s4.811,7.56,4.811,7.56s1.203,4.639,2.577,6.873 c1.375,2.234,2.921,3.78,3.265,4.983c0.344,1.203,0.515,6.701,2.234,7.732c1.718,1.031,2.234,0,2.234-1.203 c0-1.203-0.687-8.076-0.687-8.076s2.858,5.071,3.608,6.701c1.795,3.899,3.093,4.639,3.952,3.952 c0.859-0.687,0.344-2.749-0.172-5.155c-0.516-2.406-1.718-4.124-1.718-5.498c0-1.375-0.172-3.265-0.172-3.265 s3.95,11.777,4.811,12.543c0.729,0.649,0.976,1.025,2.406,0.344c0.595-0.284,0.174-2.302-0.172-3.265 c-0.65-1.808-2.375-8.487-2.375-8.487s4.437,7.456,5.124,8.144c0.687,0.687,2.062,0.859,2.405-0.687 c0.344-1.546-1.203-3.265-1.89-4.811c-0.687-1.546-2.749-6.357-2.749-6.357s0.84,2.985,4.467,3.436 c1.023,0.128,3.093,0,3.608-1.031c0.516-1.031-0.515-2.234-1.031-2.406c-0.515-0.172-4.242-0.207-5.385-2.079 c-1.144-1.873-2.69-3.934-4.065-4.622c-1.375-0.687-9.278-4.467-9.278-4.467s-2.062-12.886-3.952-17.697 c-1.89-4.811-3.608-5.67-4.639-6.873c-1.031-1.203-1.375-7.216-3.78-11.34c-2.406-4.124-3.436-7.732-3.436-7.732 s1.374-2.749,1.031-6.701"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M216.339,154.722 c0,0,8.884,1.885,11.038,6.73"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M226.3,154.991 c0,0,4.846,6.73,5.115,9.961"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M255.331,236.84 c-0.65-1.808-2.376-8.487-2.376-8.487s4.437,7.456,5.125,8.144c0.687,0.687,2.062,0.859,2.405-0.687 c0.344-1.546-1.203-3.265-1.89-4.811c-0.529-1.191-1.871-4.31-2.461-5.685c0.48,0.908,1.652,2.449,4.179,2.764 c1.023,0.127,3.093,0,3.608-1.031c0.516-1.031-0.515-2.234-1.031-2.406c-0.515-0.172-4.242-0.207-5.385-2.079 c-1.144-1.873-2.69-3.934-4.065-4.622c-1.375-0.687-9.278-4.467-9.278-4.467s-2.062-12.886-3.952-17.697 c-1.89-4.811-3.608-5.67-4.639-6.873c-0.837-0.976-1.221-5.123-2.623-8.855c-3.117-0.513-6.272-0.429-9.061,0.78 c-5.896,2.555-9.147,6.849-10.853,10.06c2.63,5.065,5.175,9.656,6.386,11.245c2.749,3.608,6.357,7.216,8.935,10.481 s4.811,7.56,4.811,7.56s1.203,4.639,2.577,6.873c1.375,2.234,2.921,3.78,3.265,4.983c0.344,1.203,0.515,6.701,2.234,7.732 c1.718,1.031,2.234,0,2.234-1.203c0-1.203-0.687-8.076-0.687-8.076s2.858,5.071,3.608,6.701c1.795,3.899,3.093,4.639,3.952,3.952 c0.859-0.687,0.344-2.749-0.172-5.155c-0.515-2.406-1.718-4.124-1.718-5.498c0-1.375-0.172-3.265-0.172-3.265 s3.95,11.777,4.811,12.543c0.729,0.649,0.976,1.025,2.406,0.344C256.098,239.821,255.677,237.802,255.331,236.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M208.906,186.078c0,0,1.919,6.031,3.016,8.224c1.097,2.193,2.193,3.016,3.29,2.742c1.096-0.274,1.096-0.274,1.096-0.274 s-2.056-3.153-1.645-4.935c0.411-1.782,6.168-5.483,11.377-6.854c5.209-1.371,7.95,0.548,8.498,1.234 c0.548,0.685,0.285,4.003,1.033,2.687c0.749-1.316,1.297-1.59,0.749-3.235c-0.548-1.645-0.96-3.975-1.645-5.757 c-0.685-1.782-3.153-3.564-9.047-3.838c-5.894-0.274-10.554,3.29-13.57,5.483C209.043,183.748,208.906,186.078,208.906,186.078z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M399.749,200.394 l7.446,27.921c0,0,5.174,22.227,8.069,31.534c2.896,9.307,2.879,20.247,1.845,21.695c-1.034,1.448-1.861,4.55-1.655,6.825 c0.207,2.275,0.414,5.791,0,8.48c-0.414,2.689,2.482,1.448,3.102-0.827c0.621-2.275,1.034-7.032,1.448-5.171 c0.414,1.861,0.414,7.446,0.414,9.1s-2.482,5.378-2.689,6.825c-0.207,1.448,2.275,0.621,3.309-1.034 c1.034-1.655,3.102-4.964,4.137-7.859c1.034-2.896,1.655-9.514,1.655-11.789c0-2.275-0.414-10.548-0.414-10.548 s1.917-27.246-2.055-46.404c-1.488-7.177-3.93-12.203-3.93-12.203l-4.343-22.13L399.749,200.394z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M310.453,192.367c0,0-12.203,7.239-12.823,7.653c-0.621,0.414-31.191,13.198-36.982,15.68 c-5.791,2.482-12.203,4.964-13.444,5.378c-1.241,0.414-9.928,10.962-11.582,13.444c-1.655,2.482,3.516,2.275,6.205-0.207 c2.689-2.482,11.789-6.412,11.789-6.412s-4.128,5.387-4.55,5.791c-1.412,1.351-1.13,6.264,3.41,0.949 c2.32-2.717,4.833-4.798,6.283-5.596c1.202-0.661,2.176-1.663,2.871-2.846l1.915-3.262c0,0,25.307-4.192,29.236-5.64 c3.93-1.448,16.225-4.249,19.948-6.731c3.723-2.482,11.582-6.618,11.582-6.618L310.453,192.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M240.556,228.215 c0,0,6.776-5.665,7.634-5.893"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 235.622,234.521 243.904,228.081 248.592,225.269  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M338.795,119.175c0,0-2.625,6.78-2.406,10.28c0.219,3.499,1.312,6.124-0.219,9.405c-1.531,3.281-5.03,5.687-3.937,6.999 c1.094,1.312,4.593,2.624,4.593,2.624s2.625,10.28,4.812,11.592c2.187,1.312,7.218-0.219,8.749-0.656 c1.531-0.437,1.372,1.017,1.591,4.954c0.219,3.937,0.615,6.851-2.228,7.726c-2.843,0.875-18.391,3.943-22.765,7.661 c-4.374,3.718-18.153,12.904-18.153,12.904l17.935,19.028l11.373-7.655c0,0,3.718,9.186,5.031,13.123 c1.312,3.937,3.281,11.373,3.281,11.373s-2.187,5.468-0.219,6.78c1.968,1.312,17.279,5.031,30.839,3.718 s22.746-5.468,23.402-7.218c0.656-1.75,0-3.937,0-5.249c0-1.312-0.656-11.811-0.438-13.123c0.219-1.312,2.187-6.124,2.187-6.124 l20.707-6.628c0,0-12.991-29.15-18.694-31.051c-2.784-0.928-20.604-0.596-23.01-1.034c-2.406-0.437-3.718-2.625-4.812-7.436 c-1.094-4.812-2.187-11.154-2.187-11.154s1.312-20.122-8.092-30.183c-9.405-10.061-19.684-6.124-22.965-4.156 C339.889,117.644,338.795,119.175,338.795,119.175z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 350.387,159.419 357.734,156.413 352.39,162.258  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M339.085,149.671 c0,0,3.54,0.536,5.579-2.789"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M342.672,138.057c0,0.992-0.443,1.796-0.989,1.796s-0.989-0.804-0.989-1.796 c0-0.992,0.443-1.796,0.989-1.796S342.672,137.064,342.672,138.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M339.299,134.115 c0,0,2.575-3.004,4.613-0.429"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M358.953,98.886 c0.975,0-18.526,0.244-21.695,2.925c-3.169,2.681,0,5.363,0,5.363s-12.432,4.875-10.725,6.581s9.507,0.975,9.507,0.975 s-14.382,9.507-8.044,9.75c6.338,0.244,10.238-3.656,10.238-3.656s4.875,12.188,7.8,9.75c2.925-2.438,3.656-5.119,3.656-5.119 s0.975,19.501,4.388,17.551c3.413-1.95,4.875-3.413,4.875-3.413s-4.388,17.307-1.219,16.819c3.169-0.488,6.825-5.119,6.825-5.119 s-2.681,18.77,4.388,19.257s11.457-9.019,11.457-9.019s0.975,9.994,3.413,8.775s4.388-5.119,4.388-5.119s3.413,3.656,4.875,0 c1.462-3.656,1.706-9.263,1.706-9.263s3.413,1.706,4.631-0.731c1.219-2.438,0.731-11.944,0.731-11.944s2.438,3.169,3.656-0.975 c1.219-4.144-1.463-12.919-1.463-12.919s3.413,1.463,2.681-6.338c-0.731-7.8-1.607-14.451-10.808-20.112 c-11.98-7.372-13.568-1.582-13.568-1.582s-2.681-8.044-7.069-7.069c-4.388,0.975-1.95,4.144-1.95,4.144s-9.019-5.85-10.969-3.9 C358.709,96.449,358.953,98.886,358.953,98.886z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M321.851,413.666c0,0-1.694,4.406-4.067,9.15c-2.372,4.744-1.695,5.761-7.795,10.844c-6.1,5.083-10.845,7.456-11.522,11.522 c-0.678,4.067,4.744,5.422,12.2,3.389c7.456-2.033,11.861-6.439,13.895-7.795c2.033-1.356,3.389,2.033,4.406-6.439 c1.017-8.472,2.711-15.928,2.711-15.928L321.851,413.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M310.667,448.572c7.456-2.033,11.861-6.439,13.895-7.794c2.033-1.356,3.389,2.033,4.406-6.439c0,0-3.626,2.4-5.527,3.35 s-10.456,7.287-15.842,8.555c-1.48,0.348-2.837,0.425-4.025,0.353c-3.137-0.19-5.106-1.414-5.106-1.414 C297.789,449.25,303.211,450.605,310.667,448.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M421.668,413.666c0,0,1.694,4.406,4.067,9.15c2.372,4.744,1.694,5.761,7.794,10.844c6.1,5.083,10.845,7.456,11.522,11.522 c0.678,4.067-4.745,5.422-12.2,3.389c-7.456-2.033-11.861-6.439-13.895-7.795c-2.033-1.356-3.389,2.033-4.406-6.439 c-1.017-8.472-2.711-15.928-2.711-15.928L421.668,413.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M432.851,448.572c-7.456-2.033-11.861-6.439-13.895-7.794c-2.033-1.356-3.389,2.033-4.406-6.439c0,0,3.626,2.4,5.527,3.35 c1.901,0.951,10.456,7.287,15.842,8.555c1.48,0.348,2.837,0.425,4.026,0.353c3.137-0.19,5.106-1.414,5.106-1.414 C445.729,449.25,440.307,450.605,432.851,448.572z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M423.697,363.175c0-7.201-3.388-28.802-3.388-28.802l-3.961-42.108c0,0-1.448-16.339-4.343-25.44 c-2.896-9.1-10.548-23.578-10.548-23.578l-0.983-11.433l-54.241,3.499l0.416,7.313c0,0-5.171,15.926-6.618,23.992 c-1.448,8.066-4.757,19.028-4.757,19.028l-1.655,6.618l-3.529,42.532c0,0-7.624,21.178-8.048,37.274 c-0.424,16.095-4.236,47.016-4.236,47.016s6.777,2.541,10.166,2.118c3.388-0.424,5.506-1.694,5.506-1.694l41.926-126.618 l4.119,0.634l14.525,59.908l15.248,65.229c0,0,4.659,3.389,6.353,2.965c1.694-0.423,6.777,0,9.318-5.083 C427.509,411.461,423.697,370.375,423.697,363.175z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M374.445,243.421 l0.704,4.223l1.056,25.34c0,0,3.519-4.575,3.871-6.335c0.352-1.76,0.352-9.15,0.352-9.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M389.226,239.902 l0.352,4.223c0,0-3.519,1.76-7.039,1.408"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M355.088,241.309 l0.352,3.871c0,0,4.575,0.704,8.447,0.704"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M379.103,242.826 c0,0.727-0.59,1.317-1.317,1.317s-1.317-0.59-1.317-1.317c0-0.727,0.59-1.317,1.317-1.317S379.103,242.099,379.103,242.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M390.892,247.27 c0,0,7.097,6.15,13.72,6.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M354.935,247.98 c0,0-5.204,8.516-11.591,10.882"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M402.222,207.317l20.707-6.628c0,0-10.456-27.565-18.694-31.051c-2.294-0.97-13.81-0.689-20.575-0.887 c-3.09,4.355-8.523,10.336-15.71,11.619c-11.582,2.068-18.201-8.273-18.201-8.273c-2.843,0.875-18.391,3.943-22.765,7.661 c-4.374,3.718-18.153,12.904-18.153,12.904l17.935,19.028l11.373-7.655c0,0,3.718,9.186,5.031,13.123 c1.312,3.937,3.281,11.373,3.281,11.373s-2.187,5.468-0.219,6.78c1.968,1.312,17.279,5.031,30.839,3.718 c13.56-1.312,22.746-5.468,23.402-7.217c0.656-1.75,0-3.937,0-5.249c0-1.312-0.656-11.811-0.438-13.123 C400.254,212.129,402.222,207.317,402.222,207.317z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 338.139,
    y1: 204.037,
    x2: 339.582,
    y2: 196.991
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M402.222,207.317 c0,0-1.86-9.091-4.083-15.021"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M391.221,208.109 c0,0-0.247,5.683-10.377,14.083"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M384.303,214.533 c0,0-0.494,4.2-9.636,10.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M364.043,239.241 c0,0-4.447-0.988-6.424-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M387.021,236.523 c0,0,4.694-2.224,5.683-5.189"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M346.748,175.001 c0,0,8.401,8.401,14.824,8.648"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M386.527,170.554 c0,0-2.224,5.189-5.683,7.906"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M322.49,425.015"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M175.599,297.943c0,0-4.757,2.762-5.678,3.069c-0.921,0.307-1.535-0.307-0.767-1.228c0.767-0.921,1.381-1.688,1.381-1.688 s-2.148,1.074-2.302-0.153c-0.153-1.228,3.069-2.148,3.069-2.148s-4.4-1.628-2.148-1.995c2.045-0.333,1.713,0.452,3.411-1.061 c0.802-0.715,0.229-4.572,0.382-5.032c0.154-0.46,2.806,2.871,2.806,2.871S176.213,295.641,175.599,297.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M173.074,256.276l3.529,16.419c0,0,2.609,8.286,2.609,10.588c0,2.302-1.535,15.038-1.841,16.112 c-0.307,1.074-1.381,4.603-2.302,4.603s-1.381-0.614-1.074-2.609c0.307-1.995,0.767-5.524,0.767-5.524l-2.263-8.309 c0,0-1.113-0.437-1.727,1.404s-1.535,6.291-2.455,6.752c-0.921,0.46-2.302-0.307-1.535-2.916 c0.767-2.609,1.228-7.059,1.688-9.053c0.46-1.995,2.302-9.36,2.302-9.36l-8.286-13.657L173.074,256.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M164.81,220.685 l7.036,30.23l-11.467,3.127c0,0-2.966-24.61-2.656-28.332C158.035,221.988,161.944,214.17,164.81,220.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M158.803,250.138c0,0,11.816-4.757,13.043-3.99c1.228,0.767,3.069,9.36,3.069,10.895c0,1.535-12.89,5.217-13.964,4.757 C159.878,261.34,158.803,250.138,158.803,250.138z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M165.018,353.362c0,0,1.458,24.927-0.35,44.814c-1.4,15.405,3.423,29.187,3.423,29.187s14.944,10.66,18.205,11.203 c3.262,0.544,8.67,1.796,5.952,5.602c-2.718,3.806-3.265,3.191-6.527,3.734c-3.262,0.544-18.484-1.087-23.921-1.631 c-5.437-0.544-8.699,0.544-12.504-1.087c-3.806-1.631-2.175-8.155,0.545-13.051c2.617-4.713,0.585-10.118-0.306-15.274 c-1.62-9.372-3.623-19.264-6.206-28.417c-1.66-5.884-3.469-14.192-3.22-20.639c0.323-8.361-1.778-20.615-1.778-20.615 S164.475,346.839,165.018,353.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M186.296,438.566c-0.61-0.102-1.629-0.557-2.882-1.231l-3.07,2.631c0,0-14.004,1.4-24.157-3.501 c-2.897-1.399-5.178-2.388-6.984-3.102c-2.308,4.701-3.402,10.323,0.093,11.821c3.806,1.631,7.068,0.544,12.504,1.087 c5.437,0.544,20.659,2.175,23.921,1.631c3.262-0.544,3.809,0.071,6.527-3.734C194.966,440.362,189.558,439.11,186.296,438.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M192.308,444.069c-1.914,0.582-4.708,1.319-7.648,1.702c-5.315,0.693-16.176-1.387-24.033-2.08 c-5.877-0.519-11.235-1.942-13.563-2.626c0.011,1.907,0.646,3.44,2.232,4.119c3.806,1.631,7.068,0.544,12.504,1.087 c5.437,0.544,20.659,2.175,23.921,1.631c3.262-0.544,3.809,0.071,6.527-3.734C192.273,444.134,192.285,444.103,192.308,444.069z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M103.629,358.198c0,0-7.975,12.404-9.41,21.55c-5.398,34.396-10.705,42.058-13.424,48.582c-2.718,6.524,2.175,9.786,4.893,10.329 c2.718,0.544,7.611,4.893,14.135,5.98c6.524,1.087,14.047,2.209,17.853,0.578c3.806-1.631,3.806-3.806,0.544-7.068 c-3.262-3.262-12.416-10.907-14.047-13.626c-0.408-0.68-0.68-1.699-0.858-2.846c-0.683-4.392,2.035-15.15,4.135-19.068 l20.403-43.468L103.629,358.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M118.219,438.151c-1.295-1.295-0.712-0.363-3.025-2.457c-0.51,0.802-1.607,1.643-3.813,2.292 c-5.952,1.751-14.557-1.68-22.764-9.222c-2.253-2.07-3.388-5.331-4.815-7.644c-1.167,3.03-2.167,5.197-3.007,7.211 c-2.718,6.524-0.3,7.771,4.893,10.329c2.487,1.225,7.611,4.893,14.135,5.98c6.524,1.087,14.047,2.209,17.852,0.578 C121.481,443.587,121.481,441.413,118.219,438.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M91.072,439.3 c-5.463-2.649-9.491-5.763-11.343-7.322c-0.418,3.488,1.928,4.695,5.959,6.681c2.487,1.225,7.611,4.893,14.135,5.98 c6.524,1.087,14.047,2.209,17.852,0.578c2.007-0.86,2.945-1.873,2.915-3.115c-2.484,1.069-5.256,2.166-6.411,2.281 C111.869,444.615,98.697,442.998,91.072,439.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M149.411,154.371 l6.486,6.658c0,0,8.78,6.318,8.399,7.463c-0.382,1.145-9.564-0.471-9.564-0.471L149.411,154.371z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M166.293,202.764l4.269,31.071c0,0-4.744,2.609-7.116,2.609c-2.372,0-2.372,0-2.372,0L166.293,202.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B5B5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M155.198,147.277c0,0-5.361,9.79-5.361,12.354c0,2.564,4.895,8.391,4.895,8.391s11.654,17.249,12.82,29.602 c1.165,12.354-4.196,28.204-4.196,35.663s2.564,50.347,2.564,50.347s5.594,43.354,5.128,49.648s1.165,32.399,1.165,32.399 s-15.419,5.881-34.765,6.114c-19.346,0.233-24.374-1.477-32.765-2.409s-12.186-6.502-12.186-6.502s3.03-67.596,4.895-82.28 s5.594-32.865,11.654-43.121c6.06-10.256,11.421-16.549,11.888-17.715c0.466-1.165-2.564-25.64-2.098-37.993 c0.466-12.354,10.023-20.279,15.384-25.407c5.361-5.128,9.79-16.549,9.79-16.549L155.198,147.277z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M135.348,351.042 c-0.787,1.83-1.572,3.465-2.348,4.848"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M151.701,292.534 c0,0-6.741,32.41-14.027,52.566"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M152.083,305.129 c0,0-4.198,22.137-7.633,30.915"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M143.479,281.458 c0.032,2.209-0.017,4.281-0.175,6.115"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M139.869,248.261 c0,0,2.724,15.434,3.445,28.624"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M142.541,242.536 c0,0,3.817,13.74,3.817,22.137"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M149.837,159.631c0,0,6.06,7.692,7.459,12.354c1.399,4.662,4.71,13.842,4.71,30.858c0,17.015-3.312,38.369-3.312,38.369 s-25.17-2.347-33.328-6.31c-8.158-3.962-14.122-9.16-14.122-9.16s4.562-35.111,7.592-47.931 c3.03-12.82,6.06-17.249,12.121-20.745C137.017,153.571,149.837,159.631,149.837,159.631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M122.886,202.086 c0,0,3.368,0,11.69-2.576"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M136.161,203.869 c0,0-9.313,5.944-17.634,8.322"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M169.13,110.773 c0,0,1.846,6.092,1.846,9.969s-1.846,4.985-1.662,7.385c0.185,2.4,3.139,5.908,3.323,7.569c0.185,1.662-3.138,3.692-3.692,3.877 s-4.246,7.939-5.354,10.339c-1.108,2.4-12.19-1.575-14.22-2.868c-2.031-1.292-4.662-5.594-4.662-5.594 s-1.056-12.769,1.529-21.815c2.585-9.046,12.185-14.585,12.185-14.585L169.13,110.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M166.361,127.389 c0,0-0.548-3.555-4.979-1.709"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M165.992,127.753c0,0.915-0.556,1.657-1.242,1.657c-0.686,0-1.242-0.742-1.242-1.657 s0.556-1.657,1.242-1.657C165.436,126.097,165.992,126.838,165.992,127.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M161.756,122.563 c0,0,4.239-2.244,6.608,1.122"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M160.135,137.525 c0,0,2.12,2.992,6.234,2.618"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M207.596,215.625l18.349,5.106c0,0,13.243-4.467,14.519-4.946c1.276-0.479,7.925-0.205,10.797,0.114 c2.872,0.319,4.042,2.12,5.318,2.758s0.798,1.755,0.798,1.755s1.276,0.479,0,1.755c-1.277,1.276-1.247,1.146-1.247,1.146 s-1.526,1.584-3.431,1.881c-2.495,0.39-3.359-0.27-4.316-0.111c-0.957,0.16-4.998,2.682-8.189,3.32 c-3.191,0.638-3.729,0.381-5.644,0.221c-1.915-0.16-4.427-1.107-4.427-1.107s-25.081-1.203-25.719-1.203 C203.767,226.315,207.596,215.625,207.596,215.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M239.531,217.558 c0,0,7.636-0.443,8.742-0.553c1.107-0.111,7.083,0.443,7.083,0.443"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M240.859,220.104 c0,0,6.529-0.553,8.632-0.553c2.103,0,7.887,0.861,7.887,0.861"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M241.633,223.313 c0,0,6.751-1.217,7.415-1.217s7.636,0.885,7.636,0.885"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M126.295,191.331c0,0,20.852,24.342,28.078,28.305c7.226,3.963,40.684,6.425,42.315,6.425c1.632,0,5.128-14.685,5.128-14.685 s-21.429-8.111-24.925-10.442c-3.496-2.331-11.45-5.343-11.45-5.343s-12.807-20.11-15.604-23.606 c-2.797-3.496-14.451-10.023-20.745-5.594"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M140.916,189.801 c0,0,5.548,6.737,20.21,6.539"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M162.191,110.449c0,0-3.03,3.962-1.399,4.895c1.632,0.932,4.196,1.165,6.293,0.233c2.098-0.932,3.962-3.729,3.962-3.729 s0,5.361,3.03,3.963c3.03-1.399,4.429-2.564,1.865-9.79c-2.564-7.226-11.887-12.121-17.948-14.451s-24.707-5.361-33.332,3.963 c-8.624,9.324-10.955,17.482-9.79,24.474c1.165,6.993,0.466,15.617-1.165,17.715c-1.632,2.098-15.617,12.121-17.015,23.076 c-1.398,10.955,5.361,16.083,6.76,19.346c1.398,3.263-1.865,4.662-3.03,3.03c-1.165-1.632-3.963,7.692,2.564,10.722 c6.526,3.03,16.083,2.331,20.046-3.263c3.963-5.594,0.932-17.715,4.895-21.211c3.963-3.496,10.256-2.797,12.82-1.166 c2.564,1.632,12.121,1.632,13.985-0.233c1.865-1.865,1.165-6.993,1.165-6.993s-2.797,2.797-4.429-1.865 c-1.632-4.662-1.398-12.354,1.632-17.715c3.03-5.361,1.865-13.752,0-18.88S162.191,110.449,162.191,110.449z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M132.405,164.316 c1.078,1.454,2.334,1.75,2.334,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M143.106,131.539 c0.23,2.183,0.108,4.54-0.716,7.088c-2.902,8.97-10.73,10.497-11.433,18.44c-0.123,1.394-0.087,2.575,0.057,3.576"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M140.262,120.003 c0.262,2.3,1.368,4.904,2.148,7.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M116.007,187.437 c-2.111,7.651-7.387,7.124-9.234,6.596"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M126.335,116.801 c-0.793,1.771-1.307,3.39-1.358,4.677c-0.264,6.596,5.804,15.83,3.957,21.635c-1.847,5.804-11.873,6.596-16.358,18.996 c-3.798,10.499,2.807,15.891,3.641,21.942"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M157.957,111.715 c0,0-4.221,4.485-8.707,5.804s-11.345,0-15.303,8.179"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M159.835,99.719 c2.871-1.723,2.871-1.723,2.871-1.723"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#B5B5B5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M130.518,112.507 c0,0,0.528-2.902,7.651-7.124c5.343-3.166,12.021-3.067,16.696-3.822"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M199.14,209.402 c0,0-6.701,14.36-6.063,16.913c0.638,2.553,9.095,4.467,11.169,3.032c2.074-1.436,5.265-13.243,5.425-14.839 c0.16-1.596-4.946-3.351-6.063-3.989C202.49,209.881,200.416,207.966,199.14,209.402z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurvision);
export default __webpack_public_path__ + "static/media/ourvision.20aa54ff92bd075915278a401c5ddaed.svg";
export { ForwardRef as ReactComponent };